import { BrandProfiles as BrandProfilesSchema } from "schemas/brand";
import { CatalogEntries as CatalogEntriesSchema } from "schemas/catalogs";
import { Attachments as AttachmentsSchema } from "schemas/attachments";
import { Events as EventsSchemas } from "schemas/events";
import InstagramsSchema from "schemas/instagram";
import siteConfig from "site-config";

export const createQuery = (data) => ({
    url: `${siteConfig.goAPI}/v1/pages`,
    body: data,
    schema: BrandProfilesSchema,
    force: true,
    options: {
        method: "POST",
    },
});

export const updateOneFieldQuery = (pageId, fieldName, value) => ({
    url: `${siteConfig.goAPI}/v1/pages/${pageId}`,
    body: {
        page: {
            [fieldName]: value,
        },
        update_mask: {
            paths: [fieldName],
        },
    },
    schema: BrandProfilesSchema,
    options: {
        method: "PATCH",
    },
    optimisticUpdate: {
        brandProfile: (prevEntities) => {
            let entry = prevEntities[pageId];
            if (!entry) {
                return prevEntities;
            }
            entry = entry.set(fieldName, value);
            return {
                ...prevEntities,
                [pageId]: entry,
            };
        },
    },
});

export const updatePagePicture = (pageId, pageMediaId) => ({
    url: `${siteConfig.goAPI}/v1/pages/${pageId}/picture`,
    body: {
        page_id: pageId,
        page_media_id: pageMediaId,
    },
    schema: BrandProfilesSchema,
    options: {
        method: "PUT",
    },
});

export const updatePageCoverPictures = (pageId, pageMediaIds) => ({
    url: `${siteConfig.goAPI}/v1/pages/${pageId}/cover_pictures`,
    body: {
        page_id: pageId,
        page_media_ids: pageMediaIds,
    },
    schema: BrandProfilesSchema,
    options: {
        method: "PUT",
    },
});

export const updatePageAttachments = (pageId, uploadId) => ({
    url: `${siteConfig.goAPI}/v1/pages/${pageId}/attachments`,
    body: {
        hidden: false,
        page_id: pageId,
        upload_id: uploadId,
    },
    schema: AttachmentsSchema,
    options: {
        method: "POST",
    },
});

export const getPageAttachments = (pageId) => ({
    url: `${siteConfig.goAPI}/v1/pages/${pageId}/attachments?filter.hidden=false`,
    body: {
        page_id: pageId,
    },
    schema: AttachmentsSchema,
    options: {
        method: "GET",
    },
});

export const destroyPageAttachment = (pageId, pageAttachmentId) => ({
    url: `${siteConfig.goAPI}/v1/pages/${pageId}/attachments/${pageAttachmentId}`,
    body: {
        page_id: pageId,
        page_attachment_id: pageAttachmentId,
    },
    schema: AttachmentsSchema,
    options: {
        method: "DELETE",
    },
});

/* Only can really update the display_name of the file */
export const updatePageAttachment = (pageId, pageAttachmentId, value) => ({
    url: `${siteConfig.goAPI}/v1/pages/${pageId}/attachments/${pageAttachmentId}`,
    body: {
        attachment: {
            display_name: value,
        },
        page_id: pageId,
        page_attachment_id: pageAttachmentId,
        update_mask: {
            paths: ["display_name"],
        },
    },
    schema: AttachmentsSchema,
    options: {
        method: "PATCH",
    },
});

/*Fetch linesheet options for brand-profile page*/

export const fetchLinesheets = (brandId) => ({
    url: "/api/v3.1/catalogs?type=linesheet&active=true&enforce_delivery_windows=include",
    // This is set to undefined on purpose, else it will break something downstream. Before, it was referencing undefined object anyway.
    schema: undefined,
});

export const fetchLinesheet = (brandId, catalogId) => ({
    url: `/api/v3.1/catalog/${catalogId}/entries?__meta=true&__guest=true&__fields=__all&__limit=15&__populate=__item&__type=item&__populate=__variant&__archived=false&__view_disabled=false&enforce_delivery_windows=include`,
    schema: CatalogEntriesSchema,
});

export const updatePageTags = (pageId, brandCategories) => ({
    url: `${siteConfig.goAPI}/v1/pages/${pageId}/brand_categories`,
    body: {
        page_id: pageId,
        brand_categories: brandCategories,
    },
    schema: BrandProfilesSchema,
    force: true,
    options: {
        method: "PUT",
    },
    optimisticUpdate: {
        brandProfile: (prevEntities) => {
            let entry = prevEntities[pageId];
            if (!entry) {
                return prevEntities;
            }
            entry = entry.set("brand_categories", brandCategories);
            return {
                ...prevEntities,
                [pageId]: entry,
            };
        },
    },
});
export const getPageEvents = (pageId) => ({
    url: `${siteConfig.goAPI}/v1/pages/${pageId}/events`,
    schema: EventsSchemas,
    force: true,
    options: {
        method: "GET",
    },
});

export const updatePageEvents = (pageId, eventId) => ({
    url: `${siteConfig.goAPI}/v1/pages/${pageId}/events`,
    body: {
        page_id: pageId,
        event_id: eventId,
    },
    schema: BrandProfilesSchema,
    force: true,
    options: {
        method: "POST",
    },
});

export const destroyPageEvent = (pageId, eventId) => ({
    url: `${siteConfig.goAPI}/v1/pages/${pageId}/events/${eventId}`,
    schema: BrandProfilesSchema,
    force: true,
    options: {
        method: "DELETE",
    },
});

export const linkInstagramAccount = (pageId, authId) => ({
    url: `${siteConfig.goAPI}/v1/pages/${pageId}/instagram`,
    body: {
        instagram_authentication_id: authId,
    },
    force: true,
    options: { method: "POST" },
});

export const unlinkInstagramAccount = (pageId) => ({
    url: `${siteConfig.goAPI}/v1/pages/${pageId}/instagram`,
    schema: BrandProfilesSchema,
    force: true,
    options: { method: "DELETE" },
    optimisticUpdate: {
        brandProfile: (prevEntities) => {
            let entry = prevEntities[pageId];
            if (!entry) {
                return prevEntities;
            }
            entry = entry.set("instagram_enabled", false);
            return {
                ...prevEntities,
                [pageId]: entry,
            };
        },
    },
});

export const getInstagramMedia = (pageId) => ({
    url: `${siteConfig.goAPI}/v1/pages/${pageId}/instagram/media`,
    schema: InstagramsSchema,
    force: true,
});
